import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, styled, Typography } from "@mui/material";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import { ForwardArrow } from "../icons/forward";
import { renderIdentifierGeneric } from "../RenderIdentifier";
import ThemeProvider from "../theme";
import { Container, ContainerStyle } from "../theme/common";
import { FONTSTYPO, SPACING } from "../theme/palette";
const CardList = styled("div")(() => ({
    "--space": SPACING.spacexss,
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "var(--space , clamp(0.75rem, calc(0.57rem + 0.88vw), 1.25rem))",
    "justifyContent": "center",
    "paddingTop": SPACING.spacexl
}));
const Card = styled("div")(() => ({
    "display": "grid",
    "flex": "1 0 20rem",
    "gap": SPACING.spacexs,
    "maxWidth": "20rem",
    "width": "100%"
}));
const BlueTypography = styled(Typography)(({ theme }) => ({
    "color": theme.palette.primary.dark
}));
const EyebrowStyle = styled(Typography)(({ theme }) => ({
    "color": theme.palette.primary.main,
    "fontSize": FONTSTYPO.stepMinues2,
    "textTransform": "uppercase"
}));
const ImgStyle = styled("img")(() => ({
    "borderRadius": "10px",
    "inlineSize": "100%"
}));
const HeaderStyle = styled("div")(() => ({
    "textAlign": "center"
}));
const ButtonOverideStyle = styled(Button)(() => ({
    "&:hover": {
        "backgroundColor": "transparent",
        "textDecoration": "underline"
    },
    "borderRadius": 0,
    "maxWidth": "max-content",
    "paddingInline": 0,
}));
const RenderRightComponent = (props) => {
    console.log("mobile", props);
    const { cards, heading } = props;
    return (_jsx(ThemeProvider, { children: _jsx(ContainerStyle, { children: _jsxs(Container, { children: [_jsx(HeaderStyle, { children: _jsx(BlueTypography, Object.assign({ variant: "h2" }, { children: heading })) }), isNotUndefinedOrNull(cards) && cards.length > 0 ? (_jsx(CardList, { children: cards.map((card, index) => (_jsxs(Card, { children: [_jsx(ImgStyle, { alt: card.title, src: card.imagePath }), _jsxs("div", { children: [isNotUndefinedOrNull(card.eyebrow) ? (_jsx(EyebrowStyle, Object.assign({ variant: "caption" }, { children: card.eyebrow }))) : (_jsx(_Fragment, {})), isNotUndefinedOrNull(card.title) ? (_jsx(BlueTypography, Object.assign({ variant: "h4" }, { children: card.title }))) : (_jsx(_Fragment, {}))] }), _jsx(Typography, Object.assign({ variant: "body1" }, { children: card.description })), isNotUndefinedOrNull(card.linkURL) && isNotUndefinedOrNull(card.linkText) ? (_jsxs(ButtonOverideStyle, Object.assign({ href: card.linkURL, size: "medium", variant: "text" }, { children: [card.linkText, " ", _jsx(ForwardArrow, { width: "14px" })] }))) : (_jsx(_Fragment, { children: " " }))] }, `${card.title}-${index}`))) })) : (_jsx(_Fragment, {}))] }) }) }));
};
const ProductRelatedArticlesStaticComponent = (props) => (_jsx(RenderRightComponent, Object.assign({}, props)));
const productRelatedArticlesStatic = (renderableData) => renderIdentifierGeneric(ProductRelatedArticlesStaticComponent, renderableData);
export { productRelatedArticlesStatic };
